/**
 * Init Google Map
 */

export function initMap($mapContainer) {
	if ($mapContainer.length) {
		var mapLat = $mapContainer.data('lat');
		var mapLng = $mapContainer.data('lng');
		var mapLocations = $mapContainer.data('locations');
		var infoBoxTemplate = $('#info-box-template').html();
		var selectedMarker, selectedInfoWindow;
		var zoom = $mapContainer.data('zoom');
		var country = $mapContainer.data('country');
		var selectedCountry = `Name IN ('${country}')`;

		if( $(window).width() < 768 && $mapContainer.data('zoom-mobile') ) {
			zoom = $mapContainer.data('zoom-mobile');
		}

		// Marker
		var markerIcon = new google.maps.MarkerImage($mapContainer.data('marker'), null, null, null, new google.maps.Size(37,56));

		var latLng = new google.maps.LatLng(mapLat, mapLng);
		var mapOptions = {
			center: latLng,
			zoomControl: false,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			mapTypeId: 'satellite',
			zoom: zoom
		};

		var map = new google.maps.Map($mapContainer[0], mapOptions);

		if ( country ) {
			var layer = new google.maps.FusionTablesLayer({
				suppressInfoWindows: true,
				query: {
					select: 'geometry',
					from: '1N2LBk4JHwWpOY4d9fobIn27lfnZ5MDy-NoqqRpk'
				},
				styles: [{
					polygonOptions: {
						fillColor: '#000000',
						fillOpacity: 0.5,
						strokeColor: '#000000',
						strokeOpacity: '0'
					}
				}, {
					where: selectedCountry,
					polygonOptions: {
						fillColor: '#ffffff',
						fillOpacity: '0'
					}
				}]
			});

			layer.setMap(map);
		}


		loadMarkers(mapLocations).then(function(response) {
			if (response.hasOwnProperty('latitude')) {
				return;
			}

			$.each(response, function(key, data) {
				var latLng = new google.maps.LatLng(
					data.latitude,
					data.longitude
				);

				var infoContent = template(infoBoxTemplate, data);

				/**
				 * Init Markers
				 */
				var marker = new google.maps.Marker({
					position: latLng,
					map: map,
					icon: markerIcon
				});

				/**
				 * Init Info Windows
				 */

				var infoWindowOffsetLeft = 25;
				var infoWindowOffsetTop = 55;

				var infoWindow = new google.maps.InfoWindow({
					content: infoContent,
					pixelOffset: new google.maps.Size(
						infoWindowOffsetLeft,
						infoWindowOffsetTop
					)
				});

				marker.addListener('click', function() {
					if (
						selectedMarker &&
						selectedInfoWindow != null &&
						selectedInfoWindow.getMap() != null
					) {
						selectedMarker.setIcon(markerIcon);
						selectedInfoWindow.close();
					} else if (selectedInfoWindow == infoWindow) {
						selectedInfoWindow = null;
					}

					selectedMarker = marker;
					selectedInfoWindow = infoWindow;
					selectedInfoWindow.open(map, marker);

					var $infoBox = $('.gm-style-iw');

					$infoBox.parent().addClass('info-window');
				});

				google.maps.event.addListener(
					infoWindow,
					'closeclick',
					function() {
						selectedMarker.setIcon(markerIcon);
					}
				);
			});
		});
	}

	/**
	 * Load markers form json file.
	 * @param  {string} src
	 */
	function loadMarkers(src) {
		return $.ajax({
			url: src,
			type: 'GET',
			dataType: 'json'
		});
	}

	/**
	 * Template structuring
	 */
	function template(str, vars) {
		return str.replace(/{{([^}]+)}}/g, function(match, property) {
			var arr = property.split('.');
			var obj = vars[arr.shift()];

			while (arr.length > 0 && typeof obj === 'object') {
				obj = obj[arr.shift()];
				console.log(obj[arr.shift()]);
			}

			return typeof obj === 'undefined' ? match : obj;
		});
	}
}


// WEBPACK FOOTER //
// ../src/assets/js/google-map.js